import React from "react";

const Placeholder = () => (
  <div className="EventCard EventCard__Placeholder">
    <div className="header">
      <div className="left-column">
        <div className="event-image">
          <div className="title-block">
            <p />
          </div>
        </div>
      </div>
      <div className="right-column">
        <div className="right-column-wrapper section-details">
          <div className="EventCard__PlaceholderText" />
          <div className="EventCard__PlaceholderText" />
          <div className="EventCard__PlaceholderText" />
        </div>
      </div>
    </div>
  </div>
);

export default Placeholder;
